import React from 'react';

import classes from '../Footer.scss';

export default function SocialLink({ href, title, children, ...rest }) {
  return (
    <a
      className = {classes.socialLink}
      href      = {href}
      target    = "_blank"
      rel       = "noopener noreferrer"
      title     = {title}
      {...rest}
    >
      {children}
    </a>
  );
}